import { createContext, useContext } from 'react';
import type { PaletteMode } from '@mui/material';

export const THEME_MODE_STORAGE_KEY = 'synapsys-theme-mode';

export type ThemeModeContextValue = {
  mode: PaletteMode;
  setMode: (mode: PaletteMode) => void;
  toggleMode: () => void;
};

export const ThemeModeContext = createContext<
  ThemeModeContextValue | undefined
>(undefined);

export const useThemeMode = () => {
  const context = useContext(ThemeModeContext);
  if (!context) {
    throw new Error('useThemeMode must be used within AppThemeProvider');
  }
  return context;
};
